import { loadStripe } from '@stripe/stripe-js'
import { PaymentSystem } from 'root-constants'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useLoadStripe = (): void => {
  const { stripePublicKey, isStripeLoaded } = useZustandStore(
    useShallow((state) => ({
      stripePublicKey: state.lead?.config?.payment?.find(
        (payment) => payment.type === PaymentSystem.STRIPE,
      )?.stripePublicKey,
      isStripeLoaded: state.isStripeLoaded,
    })),
  )

  useEffect(() => {
    if (stripePublicKey && !isStripeLoaded) {
      useZustandStore.setState({
        stripePromise: loadStripe(stripePublicKey),
        isStripeLoaded: true,
      })
    }
  }, [stripePublicKey, isStripeLoaded])
}
